import React, { useContext } from "react"
import PropTypes from "prop-types"
import AuthContext from "context/auth/authContext"
import DetailView from "./DetailView"
import DetailEdit from "./DetailEdit"

const Detail = ({
  index,
  details,
  setDetails,
  detail,
  editMode,
  setEditMode,
}) => {
  const { user } = useContext(AuthContext)

  const deleteDetail = (e, index) => {
    e.preventDefault()
    setDetails(prevArray => {
      const newArray = [...prevArray]
      newArray.splice(index, 1)
      return newArray
    })
  }

  return (
    <>
      {!editMode ? (
        <DetailView
          detail={detail}
          index={index}
          user={user}
          setEditMode={setEditMode}
          deleteDetail={deleteDetail}
        />
      ) : (
        <DetailEdit
          index={index}
          details={details}
          setDetails={setDetails}
          deleteDetail={deleteDetail}
          detail={detail}
        />
      )}
    </>
  )
}
Detail.propTypes = {
  index: PropTypes.any,
  details: PropTypes.array,
  setDetails: PropTypes.func,
  detail: PropTypes.object,
  editMode: PropTypes.bool,
  setEditMode: PropTypes.func,
}
export default Detail
